const CONFIGURATOR_ROLES = new Set(['CEO', 'TITOLARE', 'RESP_GEN', 'RESP_LOCALE']);
const APPROVER_ROLES = new Set(['CEO', 'TITOLARE', 'RESP_GEN']);

function hasRole(me, allowedRoles) {
  return (me?.role_codes || []).some((role) => allowedRoles.has(role));
}

export function canConfigureHaccp(me) {
  return hasRole(me, CONFIGURATOR_ROLES);
}

export function canApproveHaccp(me) {
  return hasRole(me, APPROVER_ROLES);
}

export function canUseHaccpTemperature(me) {
  return canConfigureHaccp(me) || hasRole(me, new Set(['DIPENDENTE']));
}
